import { defineMessages } from 'react-intl';

export default defineMessages({
  sortCriteria: {
    id: 'search.page.sortCriteria',
    defaultMessage: `{selector, select,
            price {prix décroissant}
            ascendingPrice {prix croissant}
            rating {Meilleure note}
            score {pertinence}
            other {Nombre d’avis}
        }`,
  },
  sortBy: {
    id: 'search.page.sortBy',
    // eslint-disable-next-line no-irregular-whitespace
    defaultMessage: `Trier par`,
  },
  searchTitle: {
    id: 'search.page.search.title',
    defaultMessage: `{number} {number, plural,
                      one {{isMobile, select,
                                false {professeur particulier vous correspond}
                                other {professeur}
                          }}
                      other {{isMobile, select,
                                false {professeurs particuliers vous correspondent}
                                other {professeurs}
                          }}
                  }`,
  },
});
